import moment from 'moment'
const fields = [

		// record starts here
		{
			name:'name',
			label:'ID',
			type:'text',
			values:'',
			readonly:true,
			layout:'col s6'
		},
		{
			name:'id',
			label:'Key',
			type:'number', 
			values:'',
			readonly:true,
			layout:'col s6'
		},
/* 		{
			name:'vid',
			label:'vid',
			type:'text',
			values:'',
			layout:'col s4',
			readonly:true,
		}, */
		{
			label:'rel',
			name:'Relation',
			type:'number',
			values:'',
			layout:'col s6 hide',
			readonly:false,
		},
		{
			label:'Type',
			name:'type',
			type:'select',
			readonly:false,
			layout:'col s4',
			options:[
				{
					name: 'Incoming',
					prop: 'incoming',
					id: 11,
				},
				{
					name: 'Outgoing',
					prop: 'outgoing',
					id: 12,
				}
			],
			values:new Object,
		},
		{
			name:'category',
			label:'Category',
			readonly:false,
			type:'select',
			layout:'col s4',
			values:new Object,
			options:[
				{
					name: 'Judgment',
					prop: 'judgment',
					id: 21,
				},
				{
					name: 'Letter',
					prop: 'letter',
					id: 22,
				},
				{
					name: 'Record',
					prop: 'record',
					id: 23,
				},
				{
					name: 'Cheque',
					prop: 'cheque',
					id: 24,
				},
				{
					name: 'Invoice',
					prop: 'invoice',
					id: 25,
				},
				{
					name: 'Book',
					prop: 'book',
					id: 26,
				},
				
				{
					name: 'Notice',
					prop: 'notice',
					id: 27,
				},
								
				{
					name: 'Order',
					prop: 'Order',
					id: 28,
				},
				
				
				{
					name: 'Certificate',
					prop: 'certificate',
					id: 29,
				},
												
				{
					name: 'Flash Drive',
					prop: 'flash_drive',
					id: 30,
				},
			],
		},
		{
			label:'From',
			name:'from',
			type:'model_select',
			values:new Object,
			readonly:false,
			layout:'col s6',
		},
		{
			label:'To',
			name:'to',
			type:'model_select',
			values:new Object,
			readonly:false,
			layout:'col s6',
		},
		{
			label:'Date stamp',
			name:'date_stamp',
			type:'date',
			values:moment(new Date).format('MM/DD/YYYY'),
			readonly:false,
			layout:'col s6',
		},
		{
			name:'date_corres',
			label:'Correspondent Date',
			type:'date',
			values:moment(new Date).format('MM/DD/YYYY'),
			readonly:false,
			layout:'col s6',
		},
		{
			name:'subject',
			label:'Subject',
			type:'text_area',
			values:'',
			readonly:false,
			layout:'col s12',
		},
		{
			name:'comments',
			label:'Comments',
			type:'select',
			readonly:false,
			layout:'col s4',
			options:[
				{
					name: 'Registered',
					prop: 'registered',
					id: 31,
				},	
				{
					name: 'Regular Mail',
					prop: 'regular_mail',
					id: 39,
				},
				{
					name: 'Emailed by hand',
					prop: 'emailed_by_hand',
					id: 32,
				},
				{
					name: 'By hand',
					prop: 'by_hand',
					id: 33,
				},
				{
					name: 'Emailed',
					prop: 'emailed',
					id: 34,
				},
				{
					name: 'Weighed',
					prop: 'weighed',
					id: 35,
				},
				{
					name: 'Weighed Registered',
					prop: 'weighed_registered',
					id: 36,
				},
				
			],
			values:new Object,
		},
		{
			name:'stamps',
			label:'Stamps',
			type:'number',
			values:new Number,
			readonly:false,
			layout:'col S4',
		},
		{
			name:'attachments',
			label:'Attachments',
			type:'file_upload',
			values:new Object,
			layout:'col s12 hide'
		},
		{
			name:'contents',
			label:'contents',
			type:'content_array',
			values:new Object,
			layout:'col s12'
		},
		{
			name:'routes',
			label:'Routes',
			type:'custom_array',
			values:new Array,
			layout:'col s12'
			//id: 2,
			//to: 8,//user going to id,
			//date: new Date(), //today,
			//instructions: ''
			
		},
		{
				name:'notes',
				label:'Notes',
				type:'text_area',
				values:'',
				readonly:false,
				layout:'col s12',
				
		}
		//end of record
]

const generate = () =>{
	return fields 
}

export default {
	fields, generate
}